import Cookie from 'js.cookie';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    if (!Cookie.get('alert') && $('#modal').length) {
      $('#modal').show();
    }
    
    $('.modal .btn-close').click(function() {
      $('#modal').hide();
      Cookie.set('alert', true, {
        expires: 1,
      });
    });

    // toggles hamburger and nav open and closed states
    var removeClass = true;
    $('.hamburger').click(function () {
      $('.hamburger').toggleClass('is-active');
      $('#sideNav').toggleClass('sideNav-open');
      $('.sideNavBody').toggleClass('sideNavBody-push');
      removeClass = false;
    });

    $('.sideNav').click(function() {
      removeClass = false;
    });

    document.addEventListener('touchstart', function(e) {
      if (removeClass && !$(e.target).hasClass('sideNav') && $('.sideNav').has($(e.target)).length === 0) {
        $('.hamburger').removeClass('is-active');
        $('#sideNav').removeClass('sideNav-open');
        $('.sideNavBody').removeClass('sideNavBody-push');
      }
      removeClass = true;
    }, false);

    $(window).scroll(function () {
      if ($(this).scrollTop() > 100) {
        $('.scrollup').fadeIn();
      } else {
        $('.scrollup').fadeOut();
      }
    });

    $('.scrollup').click(function () {
      $('html, body').animate({
        scrollTop: 0,
      }, 600);
      return false;
    });

    $(document).on('click touch', function(e) {

      if (e.target.id == 'sideNav' || $(e.target).parents('#sideNav').length) {

        if($(e.target).parent().hasClass('menu-item-has-children') ) {
          e.preventDefault();
          e.stopPropagation();

          var menuOpen = false;
          var parent = $(e.target).parent('.menu-item-has-children');
          var subMenu = $(e.target).siblings('.sub-menu');

          if(subMenu.hasClass('open') || parent.hasClass('open')) {
            menuOpen = true;
          }

          $('.menu-item-has-children').each(function() {
            if ($(this).hasClass('open')) {
              $(this).removeClass('open');
            }
          });

          $('.sub-menu').each(function() {
            if ($(this).hasClass('open')) {
              $(this).removeClass('open');
            }
          });

          if (menuOpen === false) {
            subMenu.addClass('open');
            parent.addClass('open');
          } else {
            subMenu.removeClass('open');
            parent.removeClass('open');
          }

        } else if(!$(e.target).hasClass('sub-menu') && $('.sub-menu').has($(e.target)).length === 0) {

          $('.menu-item-has-children').each(function() {
            if ($(this).hasClass('open')) {
              $(this).removeClass('open');
            }
          });

          $('.sub-menu').each(function() {
            if ($(this).hasClass('open')) {
              $(this).removeClass('open');
            }
          });

        }

      }

    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js